import Vue from 'vue'
import App from '@/layout/app'
import router from './router'
import store from './store'
import Plugins from './plugins'
import GlobalComponents from './components'
import Bootstrap from './bootstrap'
import VModal from 'vue-js-modal'
import Filters from './filters'
import Vodal from 'vodal'
import EventBus from './plugins/event-bus'
import Vuelidate from 'vuelidate'
import * as uiv from 'uiv'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ws from '@adonisjs/websocket-client' // Cliente de websockets

Vue.use(Loading)
Vue.use(uiv, {prefix: 'uiv'})
Vue.use(EventBus)
Vue.use(Vuelidate)
Vue.component(Vodal.name, Vodal)
Vue.use(VModal)

// registra o plugin de websockets
const wsVuePlugin = function (Vue, url, options) {
  Vue.prototype.$ws = ws(url, options)
}
Vue.use(wsVuePlugin, process.env.WS_ENDPOINT, { debug: false })

Vue.config.productionTip = false
require('izitoast/dist/css/iziToast.css')
require('vodal/common.css')
require('vodal/zoom.css')

Plugins(Vue, store, router)
Filters(Vue)
GlobalComponents(Vue)
Bootstrap(Vue, store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js